<template>
  <div class="col-sm-12 nopads">
    <div class="list-content result-table">

        <vue3-datatable
            ref="resultTable"
            :rows="recordData"
            :columns="fields"
            :pagination="false"
            :sticky-header="true"
            :height="recordData.length > 8 ? '50vh' : '100%'"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #vehicle="row">
                {{ row.value.vehicle ? row.value.vehicle.make + ' ' + row.value.vehicle.vehicle_model + ' ' + row.value.vehicle.license_plate : '' }}
            </template>
            <template #start_time="row">
                {{ toLocalTime(row.value.start_time) }}
            </template>
            <template #end_time="row">
                {{ toLocalTime(row.value.end_time) }}
            </template>
            <template #width="row">
                {{ row.value.width ? row.value.width.toFixed(2) : '' }}
            </template>
            <template #amount="row">
                {{ row.value.amount ? row.value.amount.toFixed(2) : '' }}
            </template>
            <template #start_road_num="row">
                {{ row.value.start_road_num > 0 ? row.value.start_road_num : '' }}
            </template>
            <template #start_road_sec="row">
                {{ row.value.start_road_sec > 0 ? row.value.start_road_sec : '' }}
            </template>
            <template #cell(start_distance)="row">
                {{ row.value > 0 ? Math.round(row.value) : '' }}
            </template>
            <template #end_road_num="row">
                {{ row.value.end_road_num > 0 ? row.value.end_road_num : '' }}
            </template>
            <template #end_road_sec="row">
                {{ row.value.end_road_sec > 0 ? row.value.end_road_sec : '' }}
            </template>
            <template #end_distance="row">
                {{ row.value.end_distance > 0 ? Math.round(row.value.end_distance) : '' }}
            </template>
            <template #travel_distance="row">
                {{ row.value.travel_distance > 0 ? Math.round(row.value.travel_distance) : '' }}
            </template>
            <template #surface_density="row">
                {{ calculateDensity(row.value) }}
            </template>
            <template #object_number="row">
                {{ row.value.work_order && row.value.work_order.object_number > 0 ? row.value.work_order.object_number : '' }}
            </template>
            <template #task_type="row">
                {{ row.value.work_order ? row.value.work_order.task_type.name : '' }}
            </template>

        </vue3-datatable>
    </div>
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {units} from "@/components/mixins/DeliveryNoteMixin";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: "LineUnloadRecordTable",
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        records: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            fields: [
                {field: "id", title: this.$t('common.id'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_time", title: this.$t('delivery_note.start_time'), sort: false, headerClass: 'routa-table-header'},
                {field: "end_time", title: this.$t('delivery_note.end_time'), sort: false, headerClass: 'routa-table-header'},
                {field: "vehicle", title: this.$t('delivery_note.vehicle'), sort: false, headerClass: 'routa-table-header', minWidth: '10em'},
                {field: "unload_method", title: this.$t('contract_reports.unload_records.method'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_road_name", title: this.$t('contract_reports.unload_records.start_road_name'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_road_num", title: this.$t('contract_reports.unload_records.start_road_num'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_road_sec", title: this.$t('contract_reports.unload_records.start_road_sec'), sort: false, headerClass: 'routa-table-header'},
                {field: "start_distance", title: this.$t('contract_reports.unload_records.start_road_distance'), sort: false, headerClass: 'routa-table-header'},
                {field: "end_road_name", title: this.$t('contract_reports.unload_records.end_road_name'), sort: false, headerClass: 'routa-table-header'},
                {field: "end_road_num", title: this.$t('contract_reports.unload_records.end_road_num'), sort: false, headerClass: 'routa-table-header'},
                {field: "end_road_sec", title: this.$t('contract_reports.unload_records.end_road_sec'), sort: false, headerClass: 'routa-table-header'},
                {field: "end_distance", title: this.$t('contract_reports.unload_records.end_road_distance'), sort: false, headerClass: 'routa-table-header'},
                {field: "travel_distance", title: this.$t('contract_reports.unload_records.travel_distance'), sort: false, headerClass: 'routa-table-header'},
                {field: "width", title: this.$t('contract_reports.unload_records.width'), sort: false, headerClass: 'routa-table-header'},
                {field: "amount", title: this.$t('contract_reports.unload_records.amount'), sort: false, headerClass: 'routa-table-header'},
                {field: "unit", title: this.$t('contract_reports.unload_records.unit'), sort: false, headerClass: 'routa-table-header'},
                {field: "surface_density", title: units.KILOGRAMS_PER_SQUARE_METRE, sort: false, headerClass: 'routa-table-header'},
                {field: "object_number", title: this.$t('orders.object'), sort: false, headerClass: 'routa-table-header'},
                {field: "task_type", title: this.$t('work_report.task_type'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    computed: {
        recordData() {
            let data = this.records
            return data.sort((a, b) => {
                return new Date(a.start_time) - new Date(b.start_time)
            })
        }
    },
    methods: {
        calculateDensity: function (record) {
            // Calculate if necessary info provided and unit is tons
            if ((record.travel_distance > 0 && record.width > 0 && record.amount > 0) && record.unit === units.TONS) {
                // Tons to kilograms
                let amount = record.amount * 1000
                let area = record.travel_distance * record.width
                let density = amount / area
                return density.toFixed(2);
            }
            return ''
        }
    }
}
</script>
